module.exports = { "default": require("core-js/library/fn/object/get-own-property-names"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/babel-runtime/core-js/object/get-own-property-names.js
 ** module id = 321
 ** module chunks = 1
 **/